<template>
	<div
		class="sidebar"
		:data-color="activeColor"
		:data-background-color="backgroundColor"
	>
		<div class="logo">
<!--			<a @mousedown="goToRoute($event, titleRoute)" class="simple-text logo-mini cursor-pointer">
                <div class="logo-img">
					<img :src="image" alt="Logo" />
				</div>
			</a>-->
			<a @mousedown="goToRoute($event, titleRoute)" class="simple-text logo-normal cursor-pointer">
				<template>{{ title }}</template>
			</a>
			<div class="navbar-minimize" v-if="closeButton">
				<button type="button" class="md-button md-round md-just-icon md-transparent md-theme-default" id="minimizeSidebar"
					@click="minimizeSidebar">
					<div class="md-ripple">
						<div class="md-button-content">
							<i class="material-icons text_align-center visible-on-sidebar-regular">more_vert</i>
							<i class="material-icons design_bullet-list-67 visible-on-sidebar-mini">view_list</i>
						</div>
					</div>
				</button>
			</div>
		</div>
		<div class="sidebar-wrapper" ref="sidebarScrollArea">
			<slot></slot>
			<md-list class="nav">
				<slot name="links">
					<sidebar-item v-for="(link, index) in sidebarLinks"
						:key="link.name + index"
						:link="link">
						<sidebar-item v-for="(subLink, index) in link.children"
							:key="subLink.name + index"
							:link="subLink">
						</sidebar-item>
					</sidebar-item>
				</slot>
                <slot name="actions"></slot>
			</md-list>
		</div>
	</div>
</template>
<script>
import routerMixin from "@/mixins/router-mixin"

export default {
	name: "SideBar",
    mixins: [ routerMixin ],
	data() {
		return {
			image: process.env.VUE_APP_APP_BASE_URL + '/img/laravel-vue.svg',
		}
	},
	props: {
		title: {
			type: String,
			default: "GMD"
		},
		titleRoute: {
			type: String,
			default: "Dashboard"
		},
		activeColor: {
			type: String,
			default: "purple",
			validator: value => {
				let acceptedValues = [
					"",
					"purple",
					"azure",
					"green",
					"orange",
					"danger",
					"rose"
				];
				return acceptedValues.indexOf(value) !== -1;
			}
		},
		backgroundImage: {
			type: String,
			default: `${process.env.VUE_APP_APP_BASE_URL}/img/sidebar-2.jpg`
		},
		backgroundColor: {
			type: String,
			default: "black",
			validator: value => {
				let acceptedValues = ["", "black", "white", "red"];
				return acceptedValues.indexOf(value) !== -1;
			}
		},
		logo: {
			type: String,
			default: `${process.env.VUE_APP_APP_BASE_URL}/img/vue-logo.png`
		},
		sidebarLinks: {
			type: Array,
			default: () => []
		},
		autoClose: {
			type: Boolean,
			default: true
		},
		closeButton: {
			type: Boolean,
			default: true,
		}
	},
	provide() {
		return {
			autoClose: this.autoClose
		};
	},
	methods: {
		minimizeSidebar() {
			if (this.$sidebar) {
				this.$sidebar.toggleMinimize();
			}
		},
	},
	computed: {
		sidebarStyle() {
			return {
				backgroundImage: `url(${this.backgroundImage})`
			};
		}
	},
    created() {
        bus.$on('minimise-sidebar', () => {
            if(!this.$sidebar.isMinimized) {
                this.minimizeSidebar()
            }
        })
    },
	beforeDestroy() {
		if (this.$sidebar.showSidebar) {
			this.$sidebar.showSidebar = false;
		}
	}
};
</script>
<style lang="scss">
@media (min-width: 992px) {
    .navbar-search-form-mobile,
    .nav-mobile-menu {
        display: none;
    }
}
</style>
